import {Component} from '@angular/core';
import {Events, NavController, NavParams, PopoverController, Tabs} from 'ionic-angular';
import {HttpClient} from "@angular/common/http";
import {ApiErrorHandlerProvider} from "../../providers/api-error-handler/api-error-handler";
import {TimezoneProvider} from "../../providers/timezone/timezone";
import {AdditionalServiceSuccessPage} from "../additional-service-success/additional-service-success";

/**
 * Generated class for the ServiceSummaryPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-service-summary',
    templateUrl: 'additional-service-summary.html',
})
export class AdditionalServiceSummaryPage {
    shop: any;
    booking: any;
    services: any;
    currencySymbol: string;
    errors: {};
    loading: boolean = false;

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public events: Events,
        public popoverCtrl: PopoverController,
        public tz: TimezoneProvider,
        private http: HttpClient,
        private apiErrorHandler: ApiErrorHandlerProvider) {
        this.booking = navParams.get('booking');
        this.services = navParams.get('services');
        this.shop = navParams.get('shop');
        this.setServiceTotals();

        tz.timezone(this.shop).then((currencySymbol: string) => {
            this.currencySymbol = currencySymbol;
        });
    }


    setServiceTotals(){
      this.services.totalCost = 0;
      this.services.availableTime = 0;
      this.services.services.forEach(service=>{
        this.services.totalCost += (service.price * service.quantity);
        this.services.availableTime += (service.duration * service.quantity);
      });
    }

    removeService(serviceIndex){
      this.services.services.splice(serviceIndex, 1);
      this.setServiceTotals();
    }

    backToServices(){
      this.navCtrl.pop();
    }

    addAdditionalServices() {
      this.loading = true;
      let services = this.services.services;
      return new Promise((resolve, reject) => {
        this.http.post(`/bookings/${this.booking.id}/services`, {
          services: services
        }).subscribe(res => {
          this.errors = {};
          this.openPage(services);
          this.events.publish('myChair:more-option');
          return resolve(res)
        }, error => {
          this.errors = this.apiErrorHandler.handleError(error);
          return reject(this.errors)
        }, () => {
          this.loading = false;
        })
      });
    }

    openPage(services: any) {
      this.navCtrl.popToRoot();
      // this.navCtrl.push(AdditionalServiceSuccessPage, {
      //   services: services,
      //   booking: this.booking,
      //   totalCost: this.services.totalCost,
      //   currencySymbol: this.currencySymbol
      // });
    }

}



// WEBPACK FOOTER //
// ./src/pages/additional-service-summary/additional-service-summary.ts